import { useLocation, useNavigate } from "react-router-dom";

/**
 * Custom hook that provides navigation functions that preserve search parameters
 */
export const useHandleParamNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Navigate to a path while preserving current search parameters
   * @param path - The path to navigate to
   * @param options - Navigation options
   */
  const navigateWithParams = (
    path: string | number,
    options?: { replace?: boolean; preserveParams?: boolean },
  ) => {
    const { replace = false, preserveParams = true } = options || {};

    // If navigating with a number (like -1 for back), just use standard navigate
    if (typeof path === "number") {
      navigate(path);
      return;
    }

    // If preserveParams is true and we have search parameters, append them
    if (preserveParams && location.search) {
      const fullPath = `${path}${location.search}`;
      navigate(fullPath, { replace });
    } else {
      navigate(path, { replace });
    }
  };

  return navigateWithParams;
};
